import { createFileRoute } from '@tanstack/react-router';
import { ProfileDashboard } from '@/features/profile-dashboard';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/profile-dashboard/')({
  component: ProfileDashboardRoute,
});

function ProfileDashboardRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.EmployeeView}>
      <ProfileDashboard />
    </ProtectedRoute>
  );
} 